module.exports = __webpack_public_path__ + "static/media/tokopintar.88a22ecf.png";